<template>
  <div class="plv-ia-aq-over">
    <div class="plv-ia-aq-over-table">
      <table cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th>{{ t('plvIA.answerQuickly.ranking') }}</th>
            <th>{{ t('plvIA.answerQuickly.nickname') }}</th>
            <th v-if="hasOrganization">{{ t('plvIA.answerQuickly.institution') }}</th>
            <th>{{ t('plvIA.answerQuickly.responderTimeCost') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="({useTime, timestamp, user: {nick, organization}}, i) in statistics"
            :key="timestamp"
          >
            <td>
              <div class="plv-ia-aq-over-table-range">{{ i+1 }}</div>
            </td>
            <td>{{ nick }}</td>
            <td v-if="hasOrganization">{{ organization }}</td>
            <td>{{ Number(useTime) / 1000 }} {{ t('plvIA.answerQuickly.secondsShorthand') }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="plv-ia-aq-over-btn">
      <div class="plv-ia-btn-new plv-ia-btn-blue" @click="handleClickAgainBtn">{{ t('plvIA.answerQuickly.restart') }}</div>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';

export default {
  mixins: [Locale],
  props: {
    statistics: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  computed: {
    hasOrganization() {
      return this.statistics.some(({ user: { organization } }) => !!organization);
    }
  },
  methods: {
    handleClickAgainBtn() {
      this.$emit('to-pre-start');
    }
  }
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';
.plv-ia-aq-over {
  $trH: 48px;
  height: 100%;
  padding-bottom: 64px;
  box-sizing: border-box;
  text-align: center;
  color: #333;
  font-size: 14px;
  &-table {
    width: 100%;
    height: 100%;
    padding: 16px;
    box-sizing: border-box;
    overflow: auto;
    table {
      width: 100%;
      tr {
        height: $trH;
        line-height: $trH;

        &:last-child td {
          border-bottom: 1px solid #CFD8DC;
        }
      }
      th {
        border-bottom: 1px solid #CFD8DC;
      }
      thead {
        tr {
          background: #EDF1F7;
        }
      }
      tbody {
        tr {
          background: #F8F8FB;
        }
        tr:nth-child(odd) {
          background: #fff;
        }
        $rangeBorder: 3px;
        .plv-ia-aq-over-table-range {
          $size: 24px;
          width: $size;
          height: $size;
          line-height: $size - ($rangeBorder * 2);
          box-sizing: border-box;
          border-radius: 50%;
          position: relative;
          left: 50%;
          margin-left: -$size/2;
        }
        tr:nth-child(1) {
          .plv-ia-aq-over-table-range {
            background: #ffeead;
            border: solid $rangeBorder #ffe277;
            color: #faab18;
          }
        }
        tr:nth-child(2) {
          .plv-ia-aq-over-table-range {
            background: #e9e9e9;
            border: solid $rangeBorder #d9d9d9;
            color: #7e7e7e;
          }
        }
        tr:nth-child(3) {
          .plv-ia-aq-over-table-range {
            background: #f5d9d1;
            border: solid $rangeBorder #ebc8be;
            color: #ad5d38;
          }
        }
      }
    }
  }
  &-btn {
    padding: 16px 0;
    width: 100%;
    position: relative;
  }
}
</style>
